var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66801 17.1537H13.116C14.3231 17.1537 15.3039 16.1731 15.3039 14.9658V7.26176C15.3039 6.05464 14.3233 5.07383 13.116 5.07383H7.66801C6.46089 5.07383 5.48008 6.05446 5.48008 7.26176V14.9658C5.48008 16.1729 6.46071 17.1537 7.66801 17.1537ZM6.88008 7.26162C6.88008 6.82494 7.23118 6.47369 7.66801 6.47369H13.116C13.5527 6.47369 13.9039 6.82479 13.9039 7.26162V14.9656C13.9039 15.4023 13.5528 15.7536 13.116 15.7536H7.66801C7.23133 15.7536 6.88008 15.4024 6.88008 14.9656V7.26162Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.944 14.0209H17.1854L17.1535 13.9889C17.4406 13.8987 17.644 13.6282 17.644 13.3209V6.25287C17.644 4.28958 16.0511 2.69687 14.088 2.69687H9.28799C8.89673 2.69687 8.58799 3.00562 8.58799 3.39687C8.58799 3.78813 8.89673 4.09687 9.28799 4.09687H14.088C15.2809 4.09687 16.244 5.0602 16.244 6.25291V13.3209C16.244 13.7122 16.5528 14.0209 16.944 14.0209Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyWhite);
export default __webpack_public_path__ + "static/media/copy_white.a4f4fbb3e3dfbc7db65171d1671b05fe.svg";
export { ForwardRef as ReactComponent };